import RequestCreationRefactor from "../../components/transaction/RequestCreation/RequestCreationRefactor";

/*
   context = 1 -> REQUEST CREATION OR UPDATE RIGHT AFTER REQUEST CREATION
   context = 2 -> UPDATE IN REQUEST APPROVAL
   context = 3 -> UPDATE AFTER JOB CREATION
*/

const RequestCreationNew = () => {
  return (
    <div>
      <RequestCreationRefactor context={1} />
    </div>
  );
};

export default RequestCreationNew;
